import {unwrapAPIError} from 'utils'
import {getFlightdeckBaseUrl, requestHandler} from '../HTTP'
import {HttpMethods, EndPoints} from '../HTTP/HTTP.types'
import {
  SSPMApplicationsAPIParams,
  SSPMApplicationsAPIResponseData,
  SSPMAppDetailsAPIParams,
  SSPMAppDetailsResponseData,
  SSPMOverviewAPIResponseData,
} from 'interfaces'

const flightDeckBaseUrl = getFlightdeckBaseUrl()
const SSPMNeuralBaseUrl = `${flightDeckBaseUrl}${EndPoints.SSPMNeural}`

const getSSPMApplications = async (data: {
  provider?: string
  params?: SSPMApplicationsAPIParams
}): Promise<SSPMApplicationsAPIResponseData> => {
  try {
    const {data: responseData} =
      await requestHandler<SSPMApplicationsAPIResponseData>({
        method: HttpMethods.GET,
        url: `${SSPMNeuralBaseUrl}/${data.provider}${EndPoints.SSPMApps}`,
        options: {
          params: {
            ...data.params,
          },
        },
      })
    return responseData
  } catch (error) {
    throw unwrapAPIError(error)
  }
}

const getSSPMAppDetails = async (data: {
  provider?: string
  msObjectId: string
  params?: SSPMAppDetailsAPIParams
}): Promise<SSPMAppDetailsResponseData> => {
  try {
    const {data: responseData} =
      await requestHandler<SSPMAppDetailsResponseData>({
        method: HttpMethods.GET,
        url: `${SSPMNeuralBaseUrl}/${
          data.provider
        }${EndPoints.SSPMAppDetails.replace('{msObjectId}', data.msObjectId)}`,
        options: {
          params: {
            ...data.params,
          },
        },
      })
    return responseData
  } catch (error) {
    throw unwrapAPIError(error)
  }
}

const getSSPMOverview = async (data: {
  provider?: string
}): Promise<SSPMOverviewAPIResponseData> => {
  try {
    const {data: responseData} =
      await requestHandler<SSPMOverviewAPIResponseData>({
        method: HttpMethods.GET,
        url: `${SSPMNeuralBaseUrl}/${data.provider}${EndPoints.SSPMOverview}`,
      })
    return responseData
  } catch (error) {
    throw unwrapAPIError(error)
  }
}

export const SSPMService = {
  getSSPMApplications,
  getSSPMAppDetails,
  getSSPMOverview,
}
